module.exports = __webpack_public_path__ + "fonts/BarlowCondensed-Light.e07a849.woff2";